// extracted by mini-css-extract-plugin
export default {"editSakMain":"editSak_editSakMain__3Q6mQ"};